import {
  DATA_CONNECTOR_XANO_TOKEN_URL_BEGIN,
  DATA_CONNECTOR_XANO_TOKEN_URL_SUCCESS,
  DATA_CONNECTOR_XANO_TOKEN_URL_FAILURE,
  DATA_CONNECTOR_XANO_TOKEN_URL_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function xanoTokenUrl(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_XANO_TOKEN_URL_BEGIN,
    });
    const { projectId, version } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {

      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xano/tokenurl`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_XANO_TOKEN_URL_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_XANO_TOKEN_URL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissXanoTokenUrlError() {
  return {
    type: DATA_CONNECTOR_XANO_TOKEN_URL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_XANO_TOKEN_URL_BEGIN:

      return {
        ...state,
        xanoTokenUrlPending: true,
        xanoTokenUrlError: null,
      };

    case DATA_CONNECTOR_XANO_TOKEN_URL_SUCCESS:

      return {
        ...state,
        xanoTokenUrlPending: false,
        xanoTokenUrlError: null,
        xanoTokenUrlData: action.data,
      };

    case DATA_CONNECTOR_XANO_TOKEN_URL_FAILURE:

      return {
        ...state,
        xanoTokenUrlPending: false,
        xanoTokenUrlError: action.data.error,
      };

    case DATA_CONNECTOR_XANO_TOKEN_URL_DISMISS_ERROR:

      return {
        ...state,
        xanoTokenUrlError: null,
      };

    default:
      return state;
  }
}
